/**
 *数字字典-基础配置项
 */
import {getPatentStatisticalAnalysis} from "@/plugins/api/PatentStatisticalAnalysis";
import VueCookies from 'vue-cookies'

const state = () => ({
  menuLeftList: [],
  menuRightList: [],
  dataShow: [],
  loading: false
})

const getters = {
  menuLeftList: state => state.menuLeftList,
  menuRightList: state => state.menuRightList,
  dataShow: state => state.dataShow,
  loading: state => state.loading,
}
const mutations = {
  setMenuLeftList(state, val) {
    state.menuLeftList = val
  },
  setMenuRightList(state, val) {
    state.menuRightList = val
  },
  setDataShow(state, val) {
    state.dataShow = val
  },
  setLoading(state, visible) {
    state.loading = visible; // 切换遮罩的显示状态
  }
}
const actions = {
  //刷新页面，更新信息
  async getBaseConfig(options, payload) {
    // const json = await getPatentStatisticalAnalysis({}, 'patentStatistics', 'blocktitle')
    // if (json.code === 0) {
    //   if (json.data.blockTitle && json.data.blockTitle.length) {
    //     options.commit('setMenuLeftList', json.data.blockTitle[0].resList);
    //     options.commit('setMenuRightList', json.data.blockTitle[2].resList);
    //     options.commit('setDataShow', json.data.blockTitle[1].resList);
    //   }
    // }
  },
  async setLoad({ commit }, val){
    commit('setLoading', val)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/baseConfig.js